// Un campo opcional que el usuario dejo en blanco es una AUSENCIA, no una cadena vacia.
//
// Los formularios inicializan todo en '' y lo mandan tal cual. Para una columna de texto
// eso esta bien -- una sede en blanco es una sede en blanco --, pero Postgres rechaza ''
// en una columna uuid o date:
//
//   invalid input syntax for type uuid: ""
//   invalid input syntax for type date: ""
//
// Paso de verdad: no se podia crear un torneo interno sin llenar la Liga y la Fecha de
// Fin, las dos marcadas OPCIONALES en la pantalla. Y el aviso decia "Intenta
// nuevamente", que era el peor consejo: reintentar no iba a funcionar nunca.
//
// La conversion vive en el servicio y no en el formulario para que valga para todos sus
// llamadores, no solo para la pantalla donde se descubrio.

// Columnas de `torneos` que NO son texto y pueden llegar vacias desde un formulario.
// Sale del esquema real; si se agrega una columna tipada nueva, va aqui.
export const CAMPOS_TIPADOS_TORNEO = [
  'liga_id',
  'temporada_id',
  'org_id',
  'org_organizadora_id',
  'fecha_inicio',
  'fecha_fin',
  'fecha_limite_roster',
  'max_jugadores_grupo',
  'max_grupos_por_club',
  'max_grupos_por_club_categoria',
]

export const vaciosANulo = (datos, campos) => {
  if (!datos) return {}
  const lista = campos || []
  const salida = { ...datos }
  lista.forEach((campo) => {
    if (typeof salida[campo] === 'string' && salida[campo].trim() === '') {
      salida[campo] = null
    }
  })
  return salida
}
